<script>
    import MobileTabs from "@/components/MobileTabs";
    import ImageResponsive from "@/components/ImageResponsive";

    export default {
        name: "HomeAnatomy",
        components: {
            MobileTabs,
            ImageResponsive,
        },
        data() {
            return {
                selectedTabIndex: 0,
                triggers: ["Биван 2.0", "Биван Классический"],
            };
        },
        computed: {
            tabName() {
                return this.triggers[this.selectedTabIndex];
            },
        },
        methods: {
            onChangeTab(index) {
                this.selectedTabIndex = index;
            },
        },
    };
</script>

<template>
    <section class="home-anatomy">
        <h2 class="page-title">Анатомия Биванов</h2>

        <div class="home-anatomy__tabs">
            <button
                class="home-anatomy__tab outline"
                :class="{ 'is-selected': selectedTabIndex === index }"
                v-for="(trigger, index) in triggers"
                :key="index"
                @click="onChangeTab(index)"
            >
                {{ trigger }}
            </button>
        </div>

        <div class="home-anatomy__mobile desktop-hidden">
            <mobile-tabs :max-length="triggers.length" @on-change="onChangeTab">
                <span class="home-anatomy__name">{{ tabName }}</span>
            </mobile-tabs>
        </div>

        <div class="home-anatomy__content">
            <transition name="fade" v-for="(name, index) in triggers" :key="index">
                <div class="home-anatomy__image" v-if="index === selectedTabIndex">
                    <image-responsive
                        :desktop-webp="`/static/bivan/assets/home/anatomy/${index}.webp`"
                        :desktop="`/static/bivan/assets/home/anatomy/${index}.jpg`"
                        :alt="name"
                    ></image-responsive>
                </div>
            </transition>
        </div>
    </section>
</template>

<style lang="scss">
    .home-anatomy {
        --transition-duration: 0.5s;
        max-width: 940px;
        margin: 0 auto;
    }

    .home-anatomy__tabs {
        display: none;
        @include bp($bp-desktop-sm) {
            display: flex;
            justify-content: center;
            margin: 0 -4px;
            overflow-x: visible;
        }
    }

    .home-anatomy__tab {
        @include bp($bp-desktop-sm) {
            margin: 0 8px;
            padding: 12px 40px;
            color: #637381;
            font-size: 16px;
            font-weight: 700;
            line-height: 22px;
            white-space: nowrap;
            border: 2px solid #8b9ba9;
            border-radius: var(--border-half-circle);
            cursor: pointer;
            transition: color 0.2s ease-in, background-color 0.2s ease-in,
                border-color 0.2s ease-in;
            &.is-selected {
                color: #fff;
                background-color: var(--primary);
                border-color: var(--primary);
            }
            &:hover:not(.is-selected) {
                color: var(--primary);
                border-color: var(--primary);
            }
        }
    }

    .home-anatomy__mobile {
        margin-bottom: 12px;
    }

    .home-anatomy__name {
        position: relative;
        color: var(--primary);
        font-size: 18px;
        font-weight: 500;
        line-height: 28px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            display: none;
        }
    }

    .home-anatomy__content {
        position: relative;
        padding-bottom: 56%;
        overflow: hidden;
    }

    .home-anatomy__image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        img {
            margin: 0 auto;
        }
    }
</style>
